import { Page, Text, View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import {
  LTD_COMPANY_CONTRACT_FIELD_FALLBACKS,
  LTD_COMPANY_CONTRACT_FIELD_IDS,
} from "../constants/contractFields";
import ContractListItem from "../constants/listItem";
import {
  formatSerialNumber,
  getChildSerialNumber,
  getLetterMarker,
} from "../constants/serialNumbers";


const TheContract = ({ contractDetails = {}, serialNumber = 1 }) => {
  const styles = ContractStyles();
  const startDate =
    contractDetails.contractStartDate ||
    LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.contractStartDate;
  const arName =
    contractDetails.tradingName || LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.arName;
  const companyRegistrationNumber =
    contractDetails.fcaNumber ||
    LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.companyRegistrationNumber;
  const registeredAddress =
    contractDetails.businessAddress?.fullAddress ||
    LTD_COMPANY_CONTRACT_FIELD_FALLBACKS.registeredAddress;

  return (
    <View style={[styles.flexColumn, styles.gap_sm]}>
      <ContractListItem
        id="the-contract"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Contract Agreement
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm, { paddingLeft: 16 }]}>
        <ContractListItem
          marker={getChildSerialNumber(serialNumber, 0)}
          markerWidth={42}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          This Contract takes effect from{" "}
          <Text
            id={LTD_COMPANY_CONTRACT_FIELD_IDS.contractStartDate}
            style={styles.text_red}
          >
            {startDate}
          </Text>{" "}
          between the following Parties:
        </ContractListItem>

        <View
          style={[
            styles.flexColumn,
            styles.gap_sm,
            { paddingLeft: 8},
          ]}
        >
          <ContractListItem
            marker={getLetterMarker(0)}
            styles={styles}
            textStyle={styles.buttonTextSmall}
          >
            Rosemount Financial Solutions (IFA) Ltd (Company Registration Number
            05668905), whose registered office is at Rosemount House, 2-4
            Chequers Road, Basingstoke, RG21 7PU, United Kingdom (the
            “Company”); and
          </ContractListItem>

          <ContractListItem
            marker={getLetterMarker(1)}
            styles={styles}
            textStyle={styles.buttonTextSmall}
          >
            <Text
              id={LTD_COMPANY_CONTRACT_FIELD_IDS.arName}
              style={styles.text_red}
            >
              {arName}
            </Text>{" "}
            (Company Registered Number{" "}
            <Text
              id={LTD_COMPANY_CONTRACT_FIELD_IDS.companyRegistrationNumber}
              style={styles.text_red}
            >
              {companyRegistrationNumber}
            </Text>
            ) whose registered address is{" "}
            <Text
              id={LTD_COMPANY_CONTRACT_FIELD_IDS.registeredAddress}
              style={styles.text_red}
            >
              {registeredAddress}
            </Text>{" "}
            (the “Appointed Representative”), where Appointed Representative
            refers to a firm or corporation who has entered into this Contract
            with the Company to carry out Sales Activities set out in this
            Contract.
          </ContractListItem>
        </View>
        <ContractListItem
          marker={getChildSerialNumber(serialNumber, 1)}
          markerWidth={42}
          styles={styles}
          textStyle={styles.buttonTextSmall}
        >
          <ContractListItem
            marker=""
            markerWidth={42}
            styles={styles}
            textStyle={styles.buttonTextSmall}
          >
            In the event of a conflict between this Contract and any document
            mentioned within this Contract, this Contract shall prevail.
          </ContractListItem>
        </ContractListItem>
      </View>
    </View>
  );
};

export default TheContract;
